/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // if (window.innerWidth <= 750) {
  //     const $container = $('.product__slides'); // <-- adjust to your actual scroll container
  //     const $target = $('.product__slide[data-type="video"]');     
  //     const $video = $target.find('video').get(0);
  //     let alerted = false;
    
  //     function isElementInXView($el, $container) {
  //       const containerLeft = $container.scrollLeft();
  //       const containerRight = containerLeft + $container.outerWidth();
  //       const elLeft = $el.position().left;
  //       const elRight = elLeft + $el.outerWidth();
  //       return elRight > containerLeft && elLeft < containerRight;
  //     }
    
  //     $container.on('scroll', function () {
  //       if (!alerted && isElementInXView($target, $container)) {
  //         alerted = true;
  //         $('.deferred-media__poster').trigger('click');
  //       }
  //     });
    
       
  //     if (isElementInXView($target, $container)) {
  //       alerted = true;   
  //       $('.deferred-media__poster').trigger('click');
  //     }
  //   }
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



$(document).ready(function () {
  setTimeout(function () {
     if (window.innerWidth <= 750) {
          const $container = $('.product__slides'); // <-- adjust to your actual scroll container
          const $target = $('.product__slide[data-type="video"]');     
          const $video = $target.find('video').get(0);
          let alerted = false;
        
          function isElementInXView($el, $container) {
            const containerLeft = $container.scrollLeft();
            const containerRight = containerLeft + $container.outerWidth();
            const elLeft = $el.position().left;
            const elRight = elLeft + $el.outerWidth();
            return elRight > containerLeft && elLeft < containerRight;
          }
        
          $container.on('scroll', function () {
            if (!alerted && isElementInXView($target, $container)) {
              alerted = true;
              $('.deferred-media__poster').trigger('click');
            }
          });
        
           
          if (isElementInXView($target, $container)) {
            alerted = true;   
            $('.deferred-media__poster').trigger('click');
          }
      }
    }, 1500);
});



